import type { TypeLang } from '@/schema'

type HomeSeoCopy = {
	title: string
	description: string
}

const HOME_SEO_BY_LANG: Record<TypeLang, HomeSeoCopy> = {
	es: {
		title: 'Productos italianos para profesionales',
		description: 'Pasta, quesos, conservas y marcas italianas seleccionadas para hostelería y profesionales.',
	},
	en: {
		title: 'Italian products for professionals',
		description: 'Pasta, cheese, preserves and selected Italian brands for hospitality and professionals.',
	},
	fr: {
		title: 'Produits italiens pour les professionnels',
		description: 'Pâtes, fromages, conserves et marques italiennes sélectionnées pour la restauration et les professionnels.',
	},
	pt: {
		title: 'Produtos italianos para profissionais',
		description: 'Massa, queijos, conservas e marcas italianas selecionadas para a restauração e profissionais.',
	},
	de: {
		title: 'Italienische Produkte für Profis',
		description: 'Pasta, Käse, Konserven und ausgewählte italienische Marken für Gastronomie und Profis.',
	},
}

type GetHomeSeoArgs = {
	lang: TypeLang
	clientName?: string
	storeName?: string
}

export function getHomeSeo ({ lang, clientName, storeName }: GetHomeSeoArgs) {
	const copy = HOME_SEO_BY_LANG[lang] ?? HOME_SEO_BY_LANG.es
	const brand = [clientName, storeName].filter(Boolean).join(' ')

	return {
		title: copy.title,
		description: brand ? `${copy.description} ${brand}.` : copy.description,
		h1: brand ? `${brand}, ${copy.title}` : copy.title,
	}
}
